<script>

import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts
  },
  props: {
    id: {
      type: String,
      default: "sbar"
    },
    source: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "bar"
    },
    labels: {
      type: String,
      default: "default"
    },
    colors: {
      type: Array,
      default: ['#1ab7ea', '#0084ff', '#39539E', '#0077B5']
    },
    collection: "",
    show_last_modification: {
      type: Boolean,
      default: false
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    range: {
      type: Boolean,
      default: false
    },
    auxBool: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      name: window.name,
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000,
      series: [],
      options: {
        chart: {
          id: 'vuechart-example',
          type: 'bar'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
            orientation: 'vertical',
            position: 'center' // bottom/center/top
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val + "%";
          },
          style: {
            fontSize: '12px',
            colors: ["#fff"]
          }
        },
        xaxis: {
          categories: [],
          labels: {
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          max: 100,
          labels: {
            show: true,
            formatter: function (val) {
              return val + "%";
            }
          }
        },
        fill: {
          colors: []
        },
      },
    }
  },
  methods: {
    getData: function () {
      let that = this;
      if (that.show_last_modification){
        that.padding_top= '0px';
      }
      if (that.source === undefined) {
        console.error('SBar Error - Source file not defined in component.');
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      let source = that.source
      if (that.range) {
        if (that.start > 0) source = source + '&start=' + that.start.toString()
        if (that.end > 0) source = source + '&end=' + that.end.toString()
      }
      console.log('Sbar source', source)
      axios
          .get(baseURL + source)
          .then(function (response) {
            if (response.status === 200) {
              if (response.data.data === undefined || response.data.updated === undefined) {
                console.error('SBar Error - data not defined in source file.')
                return
              }
              let serie = {}
              serie['name'] = "Disponibilidad"
              serie['data'] = []
              response.data.data.reverse().map(function(entry){
                if (that.labels === 'default') {
                  that.options.xaxis.categories.push(entry.month.toString()+'/'+entry.day.toString())
                } else {
                  that.options.xaxis.categories.push(entry.label)
                }
                if (entry.count !== undefined) serie['data'].push(entry.count)
              })
              that.series.push(serie)
              that.lastUpdated = new Date(response.data.updated).toLocaleString()
              that.isBusy = false
              const titleTail = response.data['title_tail'] || ''
              that.$emit('finished', that.id, true, `Series Length: ${that.series.length}`, titleTail)
            }
            else if (response.status === 404) {
              console.error('SBar Error - Source file not found.');
              that.$emit('finished', that.id, false, '')
              return
            }
          })
          .catch(function (error) {
            console.error('Error loading SBar data. Error:', error.response);
            that.$emit('finished', that.id, false, '')
            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('idToken')
              that.$router.push({ name: 'Home' })
            }
          })
    }
  },
  created: function() {
    this.options.fill.colors = this.colors
    this.options.yaxis.max = 100
    // this.options.dataLabels.enabled = this.auxBool
    this.getData()
  }
}
</script>

<template>
  <div style="height:320px">
    <div style="text-align:left !important;">
      <VueApexCharts type="bar" height="285" :options="options" :series="series"></VueApexCharts>
    </div>
  </div>
</template>

<style scoped>
.apexcharts-legend {
  padding-right: 80px;
  line-height: 5px;
  font-size: 8px;
}
</style>